"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadowMappings = void 0;

var _rootShadows = _interopRequireDefault(require("../0_rootStyleAttributes/rootShadows"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This file provides mappings from the shadow pallet to specific usages by category.
 * It does not provide any styling, and should not - it is just for mapping.
 * The theme.js file then consumes this file to create the root application theme
 */
var shadowMappings = {
  // ================================================================================================================ //
  // Shadow Themes                                                                                                    //
  //    - prefixed with 's_'                                                                                          //
  // ================================================================================================================ //
  s_dropdown: _objectSpread({}, _rootShadows.default.shadow300),
  s_card: _objectSpread({}, _rootShadows.default.shadow200),
  s_card_active: _objectSpread({}, _rootShadows.default.shadow200_active)
};
exports.shadowMappings = shadowMappings;